import Vue from 'vue'
import '@altenar/core/dist/core.css'
import core from '@altenar/core'
import store from './store'
import config from '@/config'
import { preload } from '@/preload'
import { windowProxyObject } from '@/config/integration'
import { getPropsByWidget } from '@/utils'
import { widgets } from '@/widgets'

Vue.use(core, { projectPrefix: 'asb' })
Vue.mixin(core.propsMixin)

const mountedWidgets = {}

const deleteAltenarWidget = (container) => {
  const containerIsUsed = Object.keys(mountedWidgets).includes(container)
  if (containerIsUsed) {
    mountedWidgets[container].$destroy()
    mountedWidgets[container].$el.remove()
    delete mountedWidgets[container]
  }
}

windowProxyObject.AltenarCore = async (initParams) => {
  if (initParams.widget) {
    deleteAltenarWidget(initParams.container)
    const widgetProps = getPropsByWidget(initParams)
    const widget = await widgets[initParams.widget]
    if (widget) {
      const application = new Vue({
        store,
        render: h => {
          return h(widget, {
            props: {
              ...widgetProps
            }
          })
        }
      })
      mountedWidgets[initParams.container] = application
      const applicationContainer = document.createElement('div')
      const initParamsContainer = document.getElementById(initParams.container.slice(1))
      if (initParamsContainer) {
        initParamsContainer.appendChild(applicationContainer)
        application.$mount(applicationContainer)
        config.callbacks.load()
        return application
      }
    }
  }
}

windowProxyObject.deleteAltenarWidget = deleteAltenarWidget

windowProxyObject.preloadAltenarWidget = (initParams) => {
  __webpack_public_path__ = initParams.scriptspath + '/'
  preload(initParams).then(result => {
    config.callbacks.preload()
  })
}
